<div class="pricing-status-dialog" mat-dialog-content>
    <h4>{{pricingStatus?.name}}</h4>
    <div class="Vert-20"></div>

    <ng-container *ngIf="pricingStatus?.code == 'InitialPricing'">
        <p>Initial pricing provides a general estimate of loan pricing based on current market conditions. It is not a
            locked or
            final quote and is subject to change. Unlike final pricing quotes, which have been reviewed and pre-approved
            by the deal
            desk, initial pricing is meant for initial reference and may fluctuate.</p>

        <p>Quotes not linked to a loan application are considered initial pricing, though initial pricing can also be tied to a loan.</p>
    </ng-container>
    <ng-container *ngIf="pricingStatus?.code == 'DealDeskPricing'">
        <p>Deal Desk pricing is meant to go hand in hand with the pre-approved pricing after the analysis is complete. Selecting
        programs will provide a filter on the pricing results that the DLR or CK can access for this loan file.</p>
        
        <p>To view the agent pricing search and submit initial pricing quotes or pre-approved individual quotes, click the
        toggle for "agent view."</p>
    </ng-container>
    <ng-container *ngIf="pricingStatus?.code == 'PreApprovedPricing'">
        <p>Pre-approved pricing reflects loan terms that have been reviewed and approved by the Deal Desk. These quotes are based
        on a completed analysis and provide more reliable figures than initial pricing. They are typically used for final
        review, disclosures, or locking.</p>
        
        <p>Originators can only select quotes that are pre-approved once the Deal Desk scenarios are submitted.</p>
    </ng-container>
    <ng-container *ngIf="pricingStatus?.code == 'ReadyToLock'">
        <p>Select 'Ready for Lock' when this scenario has been reviewed and approved so that the borrower or loan originator can
        move forward with locking the rate. After checking this, any quotes shared with the client will have the status of
        "Ready to Lock."</p>
    </ng-container>
    <div class="Vert-20"> </div>
    <a href="https://support.realfinity.io/hc/en-us/articles/36501239625620-Pricing-Quote-Statuses" target="_blank"><strong>Read more about pricing quote statuses</strong></a>
</div>

<mat-dialog-actions class="float-end">
    <button mat-button class="btn btn-secondary" (click)="dialogRef.close()">Close</button>
</mat-dialog-actions>